import axios from 'axios'

const API_URL = '/admin/bad-delivery-conditions'

export default {
    list() {
        return axios.get(API_URL)
    },
    create(data) {
        return axios.post(API_URL, data)
    },
    update(id, data) {
        return axios.post(`${API_URL}/${id}`, data)
    },
    remove(id) {
        return axios.delete(`${API_URL}/${id}`)
    },
    sort(items) {
        return axios.post(`${API_URL}/sort`, {items})
    },
    icons() {
        return axios.get(`${API_URL}/icons`)
    },
    uploadIcon(file) {
        const data = new FormData()
        data.append('icon', file)
        return axios.post(`${API_URL}/icons/upload`, data)
    }
}
